
import Vue from "vue";
import Logo from "@/components/TheLogo.vue";
import { NewSessionsApiFunc } from "@/api";
import { Company } from "@/models";
import BaseDropDown, { OptionItem } from "@/components/BaseDropDown.vue";

export type DataType = {
  userOptions: OptionItem[];
  userMenuShowing: boolean;
  companyMenuShowing: boolean;
  currentPath: string;
  selectedCompanyId: string;
};

export default Vue.extend({
  name: "TheHeader",

  components: { Logo, BaseDropDown },

  data(): DataType {
    const clickAction = async () => {
      if (this.$error.networkErr) {
        return;
      }

      const { err } = await NewSessionsApiFunc().logout(this.$auth.accessToken);
      if (err != null) {
        this.$handleApiError(err, clickAction);
        return;
      }
      this.$globalData.setCompany(undefined);
      this.$auth.clear();
      this.$router.push({ name: "login" });
    };

    return {
      userOptions: [
        {
          label: "ログアウト",
          classes: [],
          clickAction,
        },
      ],
      userMenuShowing: false,
      companyMenuShowing: false,
      currentPath: this.$router.currentRoute.path,
      selectedCompanyId: this.$globalData.companyId || "",
    };
  },

  computed: {
    isShow(): boolean {
      return this.selectedCompanyId != "df10f697-270a-46b0-9b89-2a78be9afd6d"
    },

    isAdmin(): boolean {
      return this.$auth.role === "admin";
    },

    companies(): Array<Company> {
      return this.$globalData.companies.filter(
        (c) => c.id !== this.selectedCompanyId
      );
    },

    companyOptions(): Array<OptionItem> {
      const options = [] as OptionItem[];
      if (!(this.currentPath || "").startsWith("/admin/companies")) {
        options.push({
          label: "会社一覧へ",
          classes: [],
          clickAction: () => {
            this.$globalData.setCompany(undefined);
            if (this.isAdmin) {
              this.$router.push({ name: "admin-companies" }).catch((err) => {
                err;
              });
            } else {
              this.$router.push({ name: "companies" }).catch((err) => {
                err;
              });
            }
            this.companyMenuShowing = false;
          },
        });
      }

      return options.concat(
        this.companies.map(
          (c): OptionItem => {
            return {
              label: c.name || "",
              classes: [],
              clickAction: () => {
                this.$auth.setCompanyId(c.id || "");
                this.$globalData.setCompany(c);
                this.$router.go(0);
                this.companyMenuShowing = false;
              },
            };
          }
        )
      );
    },

    shouldShowCompanySelector(): boolean {
      return !!this.selectedCompanyId;
    },

    shouldShowLoginId(): boolean {
      return !this.shouldShowCompanySelector;
    },
  },

  mounted() {
    this.$router.afterEach((to, from) => {
      this.currentPath = to.path;
      this.selectedCompanyId = this.$globalData.companyId || "";
    });

    if (this.selectedCompanyId) {
      this.$auth.setCompanyId(this.selectedCompanyId);
    }
  },

  methods: {
    reload(): void {
      if (this.$globalData.loading) {
        return;
      }
      this.$error.reloadFunc ? this.$error.reloadFunc() : location.reload();
    },
  },
});
